export const buildAdvancedLegendItems = (data, { getTooltipContent } = {}) =>
  data.map((item) => ({
    id: item.id,
    name: item.name?.replace('End-', ''),
    color: item.color,
    tooltipContent: getTooltipContent ? getTooltipContent(item) : null,
  }));
